import { render } from "./noteCard.vue?vue&type=template&id=08f77a1f&scoped=true"
import script from "./noteCard.vue?vue&type=script&lang=js"
export * from "./noteCard.vue?vue&type=script&lang=js"

import "./noteCard.vue?vue&type=style&index=0&id=08f77a1f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-08f77a1f"

export default script